import { render, staticRenderFns } from "./associatedOption.vue?vue&type=template&id=04a006fb&scoped=true"
import script from "./associatedOption.vue?vue&type=script&lang=js"
export * from "./associatedOption.vue?vue&type=script&lang=js"
import style0 from "./associatedOption.vue?vue&type=style&index=0&id=04a006fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a006fb",
  null
  
)

export default component.exports